import { gql } from '@apollo/client'

export const CHECK_FOR_CHAT_HISTORY = gql`
  query ChatHistory($caseId: String!) {
    chats {
      chatHistory(caseId: $caseId) {
        messageId
        userId
        conversationId
        content
        timestamp
        type
        isStreaming
        caseId
        pillsMessages
        documentList {
          fileName
          documentId
        }
        leftPanels {
          debtorName
          items {
            type
            status
          }
        }
      }
    }
  }
`
